import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import { useState, useEffect, useContext } from 'react'
import { createClient } from '@sanity/client'
import {
  fetchVisaTypesData,
  fetchMigrantVisasData,
  fetchResidentVisasData,
  fetchTouristVisasData,
} from '../../api'
import { toast } from 'react-toastify'
import Card from '../card'
import COPY from '../../utils/copy'
import WindowWidthContext from '../../context/window'

export default function Visas() {
  const windowWidth = useContext(WindowWidthContext)

  const [isLoading, setIsLoading] = useState(true)

  const [visaTypesData, setVisaTypesData] = useState<
    { _id: string; type: string; description: string }[]
  >([])
  const [migrantVisasData, setMigrantVisasData] = useState<
    { _id: string; title: string; description: string }[]
  >([])
  const [touristVisasData, setTouristVisasData] = useState<
    { _id: string; title: string; description: string }[]
  >([])
  const [residentVisasData, setResidentVisasData] = useState<
    { _id: string; title: string; description: string }[]
  >([])

  useEffect(() => {
    const client = createClient({
      projectId: COPY.SANITY_PROJECT_ID,
      dataset: COPY.SANITY_DATASET,
      apiVersion: COPY.SANITY_API_VERSION,
      useCdn: true,
    })

    client
      .fetch(fetchVisaTypesData)
      .then((data) => {
        setVisaTypesData(data)
      })
      .catch((error) =>
        toast.error(error, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        }),
      )
    client
      .fetch(fetchMigrantVisasData)
      .then((data) => {
        setMigrantVisasData(data)
      })
      .catch((error) =>
        toast.error(error, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        }),
      )
    client
      .fetch(fetchResidentVisasData)
      .then((data) => {
        setResidentVisasData(data)
      })
      .catch((error) =>
        toast.error(error, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        }),
      )
    client
      .fetch(fetchTouristVisasData)
      .then((data) => {
        setTouristVisasData(data)
      })
      .catch((error) =>
        toast.error(error, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        }),
      )
    setIsLoading(false)
  }, [])

  const isMobile = windowWidth && windowWidth <= 767

  return (
    <section
      id={COPY.VISAS_ID}
      className='h-100% w-screen px-4 py-6 sm:p-24 bg-gray-50 flex flex-col justify-center items-center'
    >
      <h1 className='text-3xl sm:text-5xl text-black font-black mb-6 sm:mb-12 text-center'>
        {COPY.VISAS_HEADER}
      </h1>
      {isLoading ? (
        <p className='text-black font-medium tracking-wide text-lg'>{COPY.LOADING}</p>
      ) : (
        <Tabs>
          <TabList>
            <Tab>
              <span className='font-medium active:font-bold text-bold tracking-wide text-black hover:text-blue-700'>
                {isMobile ? 'Types' : COPY.TAB_1}
              </span>
            </Tab>
            <Tab>
              <span className='font-medium active:font-bold text-bold tracking-wide text-black hover:text-blue-700'>
                {isMobile ? 'Visitor' : COPY.TAB_2}
              </span>
            </Tab>
            <Tab>
              <span className='font-medium active:font-bold text-bold tracking-wide text-black hover:text-blue-700'>
                {isMobile ? 'Migrant' : COPY.TAB_3}
              </span>
            </Tab>
            <Tab>
              <span className='font-medium active:font-bold text-bold tracking-wide text-black hover:text-blue-700'>
                {isMobile ? 'Resident' : COPY.TAB_4}
              </span>
            </Tab>
          </TabList>
          <TabPanel>
            {isLoading ? (
              <p className='text-black font-medium tracking-wide text-lg'>{COPY.LOADING}</p>
            ) : (
              <div className='grid gap-8 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 mt-6 sm:mt-12'>
                {visaTypesData.map((type) => (
                  <Card key={type._id} title={type.type} body={type.description} />
                ))}
              </div>
            )}
          </TabPanel>
          <TabPanel>
            {isLoading ? (
              <p className='text-black font-medium tracking-wide text-lg'>{COPY.LOADING}</p>
            ) : (
              <div className='grid gap-8 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 mt-12'>
                {touristVisasData.map((visa) => (
                  <Card key={visa._id} title={visa.title} body={visa.description} />
                ))}
              </div>
            )}
          </TabPanel>
          <TabPanel>
            {isLoading ? (
              <p className='text-black font-medium tracking-wide text-lg'>{COPY.LOADING}</p>
            ) : (
              <div className='grid gap-8 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 mt-12'>
                {migrantVisasData.map((visa) => (
                  <Card key={visa._id} title={visa.title} body={visa.description} />
                ))}
              </div>
            )}
          </TabPanel>
          <TabPanel>
            {isLoading ? (
              <p className='text-black font-medium tracking-wide text-lg'>{COPY.LOADING}</p>
            ) : (
              <div className='grid gap-8 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 mt-12'>
                {residentVisasData.map((visa) => (
                  <Card key={visa._id} title={visa.title} body={visa.description} />
                ))}
              </div>
            )}
          </TabPanel>
        </Tabs>
      )}
    </section>
  )
}
